// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // production: false,
  
  // APP_URL: "http://localhost",
  // API_URL: "http://localhost:4510/api/admin/",
  // ADMIN_URL: "http://localhost:4510/api/admin/",
  // SOCKET_URL: "http://localhost:4510/",
  // RESOURCE_URL: "http://localhost/",
  production: true,
  APP_URL: "https://manage.srspco.com",
  API_URL: "http://manage.srspco.com/api/admin/",
  ADMIN_URL: "https://manage.srspco.com/api/admin/",
  RESOURCE_URL: "https://manage.srspco.com",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
